// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 374) return "static/chunks/374-25f1b46fe73a6d02.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"140":"1e78b08f","239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"140":"b1f52de59c9a39b6","239":"013e6579f2be5e27","403":"6ee31fb05216abab","553":"f5c359d3df2a0015","863":"087ec403d4115960"}[chunkId] + ".js";
};